import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalContent, ModalOverlay } from "@chakra-ui/modal";
import { HiLightBulb, HiOutlineInformationCircle } from "react-icons/hi";
import { CloseButton } from "../../buttons/CloseButton";
import { translate } from "ui/i18n";
import { Trans } from "react-i18next";
import { useState } from "react";
import { i18nKey } from "domain/entities/activities.entities";
import ConsigneExempleDesktop from "ui/assets/images/technique-consignes/consigne-exemple-desktop.png";
import DownloadConsigneDesktop from "ui/assets/images/technique-consignes/download-consigne-desktop.png";
import ConsigneExempleMobile from "ui/assets/images/technique-consignes/consigne-exemple-mobile.png";
import DownloadConsigneMobile from "ui/assets/images/technique-consignes/download-consigne-mobile.png";
import { useWindowWidth } from "ui/utils/hooks";

export function ConsigneInfos({ className }: { className?: string }) {
  const isDesktop = useWindowWidth();
  const modalState = useDisclosure();
  const [step, setStep] = useState<1 | 2>(1);

  return (
    <>
      <button className={className} type="button" onClick={modalState.onOpen}>
        <HiOutlineInformationCircle size={24} />
      </button>

      <Modal isOpen={modalState.isOpen} onClose={modalState.onClose} isCentered>
        <ModalOverlay />
        <ModalContent
          maxW="500px"
          margin="20px"
          className="!rounded-[30px] !bg-darkGrey-800 p-8"
        >
          <div className="flex items-center justify-between">
            <span className="flex items-center rounded-[36px] bg-yellow-200 px-3 py-1 text-xs font-semibold text-yellow-700">
              <HiLightBulb size={12} className="me-2" />
              {translate("ns1:TechniqueConsignes.Tip")}
            </span>
            <CloseButton
              onClick={modalState.onClose}
              hideText
              light
              size={24}
            />
          </div>

          {step === 1 && (
            <div className="mt-4 text-white">
              <Trans
                i18nKey={"TechniqueConsignes.ConsigneModalText1" as i18nKey}
                components={[<span className="font-bold" />]}
              />
              <img
                src={isDesktop ? ConsigneExempleDesktop : ConsigneExempleMobile}
                alt="consigne exemple"
                className="mt-4 w-full md:mt-8"
              />
              <div
                className={`mt-8 flex items-center ${
                  isDesktop ? "justify-between" : "justify-center"
                }`}
              >
                {isDesktop && <span className="w-[100px]" />}
                <div className="flex items-center space-x-4">
                  <span className="h-[10px] w-[10px] rounded-full bg-white" />
                  <button
                    className="h-[10px] w-[10px] rounded-full bg-secondaryGrey-800"
                    onClick={() => setStep(2)}
                  />
                </div>
                {isDesktop && (
                  <button
                    className="w-[100px] rounded-xl bg-white py-3 text-sm font-semibold text-darkGrey-800"
                    onClick={() => setStep(2)}
                  >
                    {translate("ns1:Button.Next")}
                  </button>
                )}
              </div>
              {!isDesktop && (
                <button
                  className="mt-4 w-full rounded-xl bg-white py-3 text-sm font-semibold text-darkGrey-800"
                  onClick={() => setStep(2)}
                >
                  {translate("ns1:Button.Next")}
                </button>
              )}
            </div>
          )}

          {step === 2 && (
            <div className="mt-4 text-white">
              <Trans
                i18nKey={"TechniqueConsignes.ConsigneModalText2" as i18nKey}
                components={[<span className="font-bold" />]}
              />
              <img
                src={
                  isDesktop ? DownloadConsigneDesktop : DownloadConsigneMobile
                }
                alt="download consigne"
                className="mt-4 w-full md:mt-8"
              />
              <div
                className={`mt-8 flex items-center ${
                  isDesktop ? "justify-between" : "justify-center"
                }`}
              >
                {isDesktop && (
                  <button
                    className="w-[100px] rounded-xl bg-white py-3 text-sm font-semibold text-darkGrey-800"
                    onClick={() => setStep(1)}
                  >
                    {translate("ns1:Button.Previous")}
                  </button>
                )}
                <div className="flex items-center space-x-4">
                  <button
                    className="h-[10px] w-[10px] rounded-full bg-secondaryGrey-800"
                    onClick={() => setStep(1)}
                  />
                  <span className="h-[10px] w-[10px] rounded-full bg-white" />
                </div>
                {isDesktop && <span className="w-[100px]" />}
              </div>
              {!isDesktop && (
                <button
                  className="mt-4 w-full rounded-xl bg-white py-3 text-sm font-semibold text-darkGrey-800"
                  onClick={() => setStep(1)}
                >
                  {translate("ns1:Button.Previous")}
                </button>
              )}
            </div>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
